import Modal from "react-bootstrap/Modal";
import "./StatusModal.css";

const StatusModal = ({ showPreview, setShowPreview, approvalLogs, data }) => {
    const handleClose = () => {
        setShowPreview(false);
    };

    const orderNo =
        data?.reimbursement_order_no ??
        data?.order_no ??
        "";

    return (
        <div>
            <Modal
                className="br-reimbursement-status-modal"
                size="lg"
                show={showPreview}
                onHide={handleClose}
                centered
                scrollable
            >
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex flex-wrap align-items-center gap-1 fs-6">
                        <span>Reimbursement Order No:</span>
                        <span className="fw-semibold text-body">
                            {orderNo !== "" ? orderNo : "—"}
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="br-reimbursement-status-table-wrap">
                        <table className="table table-bordered table-sm br-reimbursement-status-table">
                            <thead>
                                <tr>
                                    <th>Department Level</th>
                                    <th>Approval Type</th>
                                    <th>L2 Approval</th>
                                    <th>L3 Approval</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{data?.department_level}</td>
                                    <td>approval</td>
                                    <td>
                                        {data?.l2_approval === "1"
                                            ? "Approved"
                                            : data?.l2_approval === "0"
                                              ? "Rejected"
                                              : "Pending"}
                                    </td>
                                    <td>
                                        {data?.l3_approval === "1"
                                            ? "Approved"
                                            : data?.l3_approval === "0"
                                              ? "Rejected"
                                              : "Pending"}
                                    </td>
                                </tr>
                                {(approvalLogs || []).map((log, idx) => {
                                    let logs = approvalLogs[idx - 1];
                                    if (logs) {
                                        return (
                                            <tr key={idx}>
                                                <td>{log.department_level}</td>
                                                <td>{log.approval_type}</td>
                                                <td>
                                                    {logs.l2_approval == "1" &&
                                                    logs.l3_approval == "1"
                                                        ? log.l2_approval == "1"
                                                            ? "Approved"
                                                            : log.l2_approval == "0"
                                                              ? "Rejected"
                                                              : "Pending"
                                                        : "-"}
                                                </td>
                                                <td>
                                                    {logs.l2_approval == "1" &&
                                                    logs.l3_approval == "1"
                                                        ? log.l3_approval == "1"
                                                            ? "Approved"
                                                            : log.l3_approval == "0"
                                                              ? "Rejected"
                                                              : "Pending"
                                                        : "-"}
                                                </td>
                                            </tr>
                                        );
                                    }
                                    return (
                                        <tr key={idx}>
                                            <td>{log.department_level}</td>
                                            <td>{log.approval_type}</td>
                                            <td>
                                                {data?.l2_approval === "1" &&
                                                data?.l3_approval === "1"
                                                    ? log.l2_approval === "1"
                                                        ? "Approved"
                                                        : log.l2_approval === "0"
                                                          ? "Rejected"
                                                          : "Pending"
                                                    : "-"}
                                            </td>
                                            <td>
                                                {data?.l2_approval === "1" &&
                                                data?.l3_approval === "1"
                                                    ? log.l3_approval === "1"
                                                        ? "Approved"
                                                        : log.l3_approval === "0"
                                                          ? "Rejected"
                                                          : "Pending"
                                                    : "-"}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default StatusModal;
